import styled from 'styled-components';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const StyledPopupMain = styled.div`
  @media ${theme.mediaQuery.mobileOnly} {
    padding-top: ${toRem(109)};
  }
`;
